import { Inject } from '@wendellhu/redi';
import { CaseService } from './case.service';
import type { CaseMaindataDTO } from '@holoview/dao-gen/generated';
import type {
  CaseAppendsQueryParams,
  CaseDetailDto,
  CaseEditableDto,
  CaseLibraryQueryParams,
  CaseLibraryRowDto,
  CaseListPageDto,
  CaseListQueryParams,
  CaseShowcaseCardDto,
  CaseShowcaseQueryParams,
} from './dto/case.dto';
import type { CaseCreateParams } from './dto/case-create.dto';

export class CaseController {
  constructor(
    @Inject(CaseService) private readonly service: CaseService,
  ) {}

  async findAll(filter: CaseListQueryParams): Promise<CaseListPageDto<CaseMaindataDTO>> {
    return this.service.findAll(filter);
  }

  async searchLibraryCases(params: CaseLibraryQueryParams): Promise<CaseListPageDto<CaseLibraryRowDto>> {
    return this.service.searchLibraryCases(params);
  }

  async findById(id: number): Promise<CaseMaindataDTO | null> {
    if (!id || id <= 0) throw new Error('Invalid case id');
    return this.service.findById(id);
  }

  async createMainData(params: CaseCreateParams): Promise<CaseMaindataDTO> {
    if (!params.name) throw new Error('Case name is required');
    return this.service.createMainData(params);
  }

  async findEditableCase(id: number): Promise<CaseEditableDto> {
    if (!id || id <= 0) throw new Error('Invalid case id');
    return this.service.findEditableCase(id);
  }

  async updateEditableCase(id: number, params: CaseCreateParams): Promise<void> {
    if (!id || id <= 0) throw new Error('Invalid case id');
    if (!params.name) throw new Error('Case name is required');
    await this.service.updateEditableCase(id, params);
  }

  async searchWithAppends(params: CaseAppendsQueryParams): Promise<CaseMaindataDTO[]> {
    return this.service.searchWithAppends(params);
  }

  async getShowcaseCaseCards(params: CaseShowcaseQueryParams): Promise<CaseShowcaseCardDto[]> {
    return this.service.getShowcaseCaseCards(params);
  }

  async findCasesWithArchiveByIds(ids: number[]): Promise<Record<string, unknown>[]> {
    return this.service.findCasesWithArchiveByIds(ids);
  }

  async findCaseDetailsByIds(ids: number[]): Promise<CaseDetailDto[]> {
    return this.service.findCaseDetailsByIds(ids);
  }
}
